'use client';

import { Children, PropsWithChildren, isValidElement } from 'react';

import { StatusBadge } from '@flipster/react/design-system/status-badge';
import FilterIcon from '@flipster/react/icon/generated/FilterIcon';
import { stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

import { Button } from './button';
import { Dropdown } from './dropdown';

export const Plugins = ({ children, showRedDot = false }: PropsWithChildren<{ showRedDot?: boolean }>) => {
  const validChildren = Children.toArray(children).filter((child) => isValidElement(child));
  if (validChildren.length === 0) return null;
  return (
    <Dropdown
      placement='bottom-start'
      trigger={
        <Button>
          <StatusBadge
            visible={showRedDot}
            css={{
              _after: {
                right: 3,
              },
            }}
          >
            <FilterIcon size={20} color={token('colors.content.default.level-3')} />
          </StatusBadge>
        </Button>
      }
      css={{ minW: 160 }}
    >
      <div className={stack({ color: 'content.default.level-5', gap: 8 })}>{children}</div>
    </Dropdown>
  );
};
